module.exports = __webpack_public_path__ + "static/media/icon_direct_api.8853e093.svg";